// Extract the script title from a ProseMirror JSON document.
// Convention: the first H1 is the title.

interface PmNode {
  type: string;
  attrs?: Record<string, unknown>;
  content?: PmNode[];
  text?: string;
}

export function extractTitle(doc: PmNode | null | undefined): string {
  if (!doc?.content?.length) return 'Untitled';
  for (const node of doc.content) {
    if (node.type === 'heading' && node.attrs?.level === 1) {
      const text = (node.content ?? [])
        .map((n) => n.text ?? '')
        .join('')
        .trim();
      return text || 'Untitled';
    }
  }
  return 'Untitled';
}
